import { render, staticRenderFns } from "./dormInvoking.vue?vue&type=template&id=2e0366cc&scoped=true"
import script from "./dormInvoking.vue?vue&type=script&lang=js"
export * from "./dormInvoking.vue?vue&type=script&lang=js"
import style0 from "./dormInvoking.vue?vue&type=style&index=0&id=2e0366cc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0366cc",
  null
  
)

export default component.exports